module.exports = __webpack_public_path__ + "static/media/LazyAz_android_2_preview.62ecc059.jpg";